import { Ability } from '@casl/ability'

export default function defineAbilities(ability) {
  return new Ability(ability)
}